const menu = {
  'dashboard': '仪表盘',
  'robot': '许可管理',
  'manage-process': '流程管理',
  'manage-task': '任务管理',
  'manage-variable': '变量管理',
  'taskdata': '任务数据',
  'log': '业务日志',
  'application': '应用管理',
  'reportforms': '报表中心',
  'reportforms-task': '任务报表',
  'reportforms-robot': '机器人报表',
  'reportforms-process': '流程报表',
  'reportforms-roi': '投资回报报表',
  finance: {
    title: '财务中心',
    overview: '费用总览',
    details: '收支明细'
  }
}

const copyright = {
  'links': '中国RPA行业领航者',
  'copyright': '艺赛旗软件'
}

// 提示消息
const tip = {
  emptyText: '暂无数据',
  success: '成功',
  error: '失败',
  editSuccess: '修改@:custom.tip.success',
  editError: '修改@:custom.tip.error',
  confirm: '确认',
  confirmSuccess: '确认@:custom.tip.success',
  confirmError: '确认@:custom.tip.error',
  addSuccess: '添加@:custom.tip.success',
  addError: '添加@:custom.tip.error',
  actionSuccess: '操作@:custom.tip.success',
  actionError: '操作@:custom.tip.error',
  deleteSuccess: '删除@:custom.tip.success',
  deleteError: '删除@:custom.tip.error',
  cancelSuccess: '取消@:custom.tip.success',
  cancelError: '取消@:custom.tip.error',
  cancelTitle: '确认要取消订单吗？',
  deleteTitle: '确认要删除吗？',
  cancelled: '已取消',
  cleared: '已清空'
}
const pagination = {
  total: '共有 {total} 条'
}

// 全局组件
const global = {
  // 搜索组件
  search: {
    placeHolder: '搜索...',
    btn: ['普通搜索', '高级搜索']
  }
}

const custom = {
  menu,
  copyright,
  tip,
  pagination,
  global
}
export default custom
